// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-text .copy-icon{color:#878b91;visibility:hidden}.copy-text.small .copy-icon{font-size:12px}.copy-text.large .copy-icon{font-size:14px}.copy-text:hover{cursor:pointer}.copy-text:hover .copy-icon{visibility:visible}", ""]);
// Exports
module.exports = exports;
